import api from './api'

/**
 * Cuestionario de levantamiento: lo que se le pregunta al prospecto ANTES de cotizar para
 * dimensionar el paquete (volumen de facturación, usuarios, sucursales, áreas).
 *
 * Lo puede llenar el asesor durante la entrevista o el cliente por el enlace que le envía
 * `enviar`. En cualquier caso el motor recalcula la sugerencia en cada guardado.
 */
export default {
  // Las preguntas viven en el servidor (data-driven): añadir una no obliga a tocar el portal.
  async getCatalogo() {
    const response = await api.get('/cd2b/levantamientos/catalogo')
    return response.data
  },
  async getAll(params) {
    const response = await api.get('/cd2b/levantamientos', { params })
    return response.data
  },
  async getById(id) {
    const response = await api.get(`/cd2b/levantamientos/${id}`)
    return response.data
  },
  async create(data) {
    const response = await api.post('/cd2b/levantamientos', data)
    return response.data
  },
  // Guarda respuestas y devuelve la sugerencia recalculada.
  async update(id, data) {
    const response = await api.put(`/cd2b/levantamientos/${id}`, data)
    return response.data
  },
  // Le manda el cuestionario al cliente para que lo responda él.
  async enviar(id) {
    const response = await api.post(`/cd2b/levantamientos/${id}/enviar`)
    return response.data
  },
  // Convierte las respuestas en una cotización prellenada y ya cotizada.
  async armarCotizacion(id, data = {}) {
    const response = await api.post(`/cd2b/levantamientos/${id}/armar-cotizacion`, data)
    return response.data
  },
}
